import '@rainbow-me/rainbowkit/styles.css';

import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { defineChain } from 'viem';
import {
  arbitrum,
  avalanche,
  base,
  bsc,
  chiliz,
  cronos,
  fantom,
  gnosis,
  linea,
  mainnet,
  monadTestnet,
  moonbeam,
  opBNB,
  optimism,
  palm,
  polygon,
  polygonZkEvm,
  ronin,
  zksync,
} from 'wagmi/chains';

import { envConfig } from '#app/config';

const gunzTestnet = defineChain({
  id: 49321,
  name: 'GUNZ Testnet',
  nativeCurrency: {
    name: 'GUN',
    symbol: 'GUN',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://rpc.gunz.dev/ext/bc/ryk9vkvNuKtewME2PeCgybo9sdWXGmCkBrrx4VPuZPdVdAak8/rpc'],
      webSocket: ['wss://rpc.gunz.dev/ext/bc/ryk9vkvNuKtewME2PeCgybo9sdWXGmCkBrrx4VPuZPdVdAak8/ws'],
    },
    public: {
      http: ['https://rpc.gunz.dev/ext/bc/ryk9vkvNuKtewME2PeCgybo9sdWXGmCkBrrx4VPuZPdVdAak8/rpc'],
      webSocket: ['wss://rpc.gunz.dev/ext/bc/ryk9vkvNuKtewME2PeCgybo9sdWXGmCkBrrx4VPuZPdVdAak8/ws'],
    },
  },
  blockExplorers: {
    default: {
      name: 'GUNZ Scan',
      url: 'https://testnet.gunzscan.io',
    },
  },
  contracts: {},
  testnet: true,
});

const gunzMainnet = defineChain({
  id: 43419,
  name: 'GUNZ Mainnet',
  nativeCurrency: {
    name: 'GUN',
    symbol: 'GUN',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: [
        'https://rpc.gunzchain.io/ext/bc/2M47TxWHGnhNtq6pM5zPXdATBtuqubxn5EPFgFmEawCQr9WFML/rpc',
      ],
    },
    public: {
      http: [
        'https://rpc.gunzchain.io/ext/bc/2M47TxWHGnhNtq6pM5zPXdATBtuqubxn5EPFgFmEawCQr9WFML/rpc',
      ],
    },
  },
  blockExplorers: {
    default: {
      name: 'GUNZ Scan',
      url: 'https://gunzscan.io',
    },
  },
  contracts: {},
  testnet: false,
});

const sonicMainnet = defineChain({
  id: 146,
  name: 'Sonic Mainnet',
  nativeCurrency: {
    name: 'Sonic',
    symbol: 'SONIC',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://sonic.drpc.org'],
    },
    public: {
      http: ['https://sonic.drpc.org'],
    },
  },
  blockExplorers: {
    default: {
      name: 'SonicScan',
      url: 'https://sonicscan.org',
    },
  },
  contracts: {},
  testnet: false,
});

const somniaMainnet = defineChain({
  id: 5031,
  name: 'Somnia Mainnet',
  nativeCurrency: {
    name: 'SOMI',
    symbol: 'SOMI',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://api.infra.mainnet.somnia.network/'],
    },
    public: {
      http: ['https://api.infra.mainnet.somnia.network/'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Somnia Explorer',
      url: 'https://explorer.somnia.network',
    },
  },
  contracts: {},
  testnet: false,
});

export const config = getDefaultConfig({
  appName: 'Zealy',
  projectId: envConfig.walletconnect.projectId,
  chains: [
    mainnet,
    polygon,
    optimism,
    arbitrum,
    base,
    bsc,
    linea,
    avalanche,
    fantom,
    cronos,
    palm,
    gnosis,
    chiliz,
    moonbeam,
    zksync,
    polygonZkEvm,
    gunzTestnet,
    gunzMainnet,
    monadTestnet,
    opBNB,
    ronin,
    sonicMainnet,
    somniaMainnet,
  ],
  ssr: true,
});
